var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RouterLink',{staticClass:"ws-info-router-link",attrs:{"to":("/" + _vm.value),"target":"_blank"}},[(_vm.value)?_c('WsIcon',[_vm._v("link")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }